// ui/particle-layer-singleton.js: M5 Change #5 wiring.
//
// One ParticleLayer per page (matches the audio-engine pattern). Call
// getParticleLayer() to acquire, first call creates the layer and
// attaches it to the overlay canvas if present in the DOM.
//
// Consumers (#10, #12, #15) call getParticleLayer().burst(...), they
// don't manage lifecycle.

import { createParticleLayer } from './particle-layer.js';

/** @type {ReturnType<typeof createParticleLayer>|null} */
let _layer = null;

export function getParticleLayer() {
  if (!_layer) {
    const reducedMotion = (typeof window !== 'undefined' && window.matchMedia)
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;
    _layer = createParticleLayer({ reducedMotion });
  }
  return _layer;
}

/**
 * Mount or remount the overlay canvas. Idempotent. Resizes the layer's
 * canvas to match the host (so origin coords align with the game
 * canvas).
 */
export function mountParticleLayer() {
  if (typeof document === 'undefined') return;
  let overlay = /** @type {HTMLCanvasElement|null} */ (document.getElementById('particle-layer'));
  if (!overlay) {
    overlay = document.createElement('canvas');
    overlay.id = 'particle-layer';
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100vw';
    overlay.style.height = '100vh';
    overlay.style.pointerEvents = 'none';
    overlay.style.zIndex = '50';
    document.body.appendChild(overlay);
  }
  resizeOverlay(overlay);
  const layer = getParticleLayer();
  layer.attach(overlay);
  if (typeof window !== 'undefined') {
    window.addEventListener('resize', () => resizeOverlay(overlay));
  }
}

function resizeOverlay(canvas) {
  if (typeof window === 'undefined') return;
  const dpr = window.devicePixelRatio || 1;
  canvas.width  = Math.round(window.innerWidth  * dpr);
  canvas.height = Math.round(window.innerHeight * dpr);
  const ctx = canvas.getContext('2d');
  if (ctx) ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}

export function _resetForTests() {
  _layer = null;
}
